import { ServerLink } from '../components/AccessComponent/GenericAccessPage';

export interface AccessPageConfig {
  serviceName: string;
  title: string;
  supportText: string;
  serverLinks: ServerLink[][];
  formUrl?: string;
  templateRef?: string;
}

export const accessPageConfigs: Record<string, AccessPageConfig> = {
  jenkins: {
    serviceName: 'Jenkins',
    title: 'Jenkins Server Access Control',
    supportText: 'Access your Jenkins server and build your projects.',
    serverLinks: [
      [
        {
          label: 'Common Staging Jenkins:',
          url: 'https://flyingdutchman.sparrowapps.com/',
        },
        {
          label: 'Common Production Jenkins:',
          url: 'https://blackpearl.sparrowapps.com/',
        },
      ],
      [
        {
          label: 'SurveySparrow Staging Jenkins:',
          url: 'https://flyingdutchman.sparrowsuite.com/',
        },
        {
          label: 'SurveySparrow Production Jenkins:',
          url: 'https://blackpearl.surveysparrow.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/jenkins-access-template',
    templateRef: 'default/jenkins-access-template',
  },
  argocd: {
    serviceName: 'ArgoCD',
    title: 'ArgoCD Server Access Control',
    supportText: 'Access your ArgoCD server and manage your deployments.',
    serverLinks: [
      [
        {
          label: 'Common Staging ArgoCD:',
          url: 'https://argocd.staging.sparrowapps.com/login/',
        },
        {
          label: 'Common Production ArgoCD:',
          url: 'https://argocd.internal.sparrowapps.com/login/',
        },
      ],
      [
        {
          label: 'SurveySparrow Staging Jenkins:',
          url: 'https://flyingdutchman.sparrowsuite.com/',
        },
        {
          label: 'SurveySparrow Production Jenkins:',
          url: 'https://blackpearl.surveysparrow.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/argocd-access-template',
    templateRef: 'default/argocd-access-template',
  },
  grafana: {
    serviceName: 'Grafana',
    title: 'Grafana Server Access Control',
    supportText: 'Access your Grafana server and monitor your data.',
    serverLinks: [
      [
        {
          label: 'Common Staging Grafana:',
          url: 'https://flyingdutchman.sparrowapps.com/',
        },
        {
          label: 'Common Production Grafana:',
          url: 'https://blackpearl.sparrowapps.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/grafana-access-template',
    templateRef: 'default/grafana-access-template'
  },
  postgres: {
    serviceName: 'Postgres',
    title: 'Postgres Server Access Control',
    supportText: 'Access your Postgres server and view your data.',
    serverLinks: [
      [
        {
          label: 'Common Staging Postgres:',
          url: 'https://flyingdutchman.sparrowapps.com/',
        },
        {
          label: 'Common Production Postgres:',
          url: 'https://blackpearl.sparrowapps.com/',
        },
      ],
      [
        {
          label: 'SurveySparrow Staging Postgres:',
          url: 'https://flyingdutchman.sparrowsuite.com/',
        },
        {
          label: 'SurveySparrow Production Postgres:',
          url: 'https://blackpearl.surveysparrow.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/postgres-access-template',
    templateRef: 'default/postgres-access-template',
  },
  opensearch: {
    serviceName: 'Opensearch',
    title: 'Opensearch Server Access Control',
    supportText: 'Access your Opensearch server and search your data.',
    serverLinks: [
      [
        {
          label: 'Common Staging Opensearch:',
          url: 'https://flyingdutchman.sparrowapps.com/',
        },
        {
          label: 'Common Production Opensearch:',
          url: 'https://blackpearl.sparrowapps.com/',
        },
      ],
      [
        {
          label: 'SurveySparrow Staging Opensearch:',
          url: 'https://flyingdutchman.sparrowsuite.com/',
        },
        {
          label: 'SurveySparrow Production Opensearch:',
          url: 'https://blackpearl.surveysparrow.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/opensearch-access-template',
    templateRef: 'default/opensearch-access-template',
  },
  clickhouse: {
    serviceName: 'Clickhouse',
    title: 'Clickhouse Server Access Control',
    supportText: 'Access your Clickhouse server and view your data.',
    serverLinks: [
      [
        {
          label: 'Common Staging Clickhouse:',
          url: 'https://flyingdutchman.sparrowapps.com/',
        },
        {
          label: 'Common Production Clickhouse:',
          url: 'https://blackpearl.sparrowapps.com/',
        },
      ],
      [
        {
          label: 'SurveySparrow Staging Clickhouse:',
          url: 'https://flyingdutchman.sparrowsuite.com/',
        },
        {
          label: 'SurveySparrow Production Clickhouse:',
          url: 'https://blackpearl.surveysparrow.com/',
        },
      ],
    ],
    formUrl: '/create/templates/default/clickhouse-access-template',
    templateRef: 'default/clickhouse-access-template',
  },
  aws: {
    serviceName: 'Cloud Services',
    title: 'Cloud Services Access Control',
    supportText: 'Access your Jenkins server and build your projects.',
    serverLinks: [
      [
        {
          label: 'SurveySparrow Organization Cloud:',
          url: 'https://surveysparrow.awsapps.com/start/#/',
        },
        {
          label: 'ThriveSparrow Organization Cloud:',
          url: 'https://thrivesparrow.awsapps.com/start/#/',
        },
      ],
    ],
    formUrl: '/create/templates/default/aws-access-template',
    templateRef: 'default/aws-access-template',
  },
  gcp: {
    serviceName: 'Cloud Services',
    title: 'Cloud Services Access Control',
    supportText: 'Access your Jenkins server and build your projects.',
    serverLinks: [
      [
        {
          label: 'SurveySparrow Organization Cloud:',
          url: 'https://surveysparrow.awsapps.com/start/#/',
        },
        {
          label: 'ThriveSparrow Organization Cloud:',
          url: 'https://thrivesparrow.awsapps.com/start/#/',
        },
      ],
    ],
    formUrl: '/create/templates/default/gcp-access-template',
    templateRef: 'default/gcp-access-template',
  },
  azure: {
    serviceName: 'Cloud Services',
    title: 'Cloud Services Access Control',
    supportText: 'Access your Jenkins server and build your projects.',
    serverLinks: [
      [
        {
          label: 'SurveySparrow Organization Cloud:',
          url: 'https://surveysparrow.awsapps.com/start/#/',
        },
        {
          label: 'ThriveSparrow Organization Cloud:',
          url: 'https://thrivesparrow.awsapps.com/start/#/',
        },
      ],
    ],
    formUrl: '/create/templates/default/azure-access-template',
    templateRef: 'default/azure-access-template',
  },
};

